// extracted by mini-css-extract-plugin
export default {"previous":"ArrowNavigation-module-previous","title":"ArrowNavigation-module-title","next":"ArrowNavigation-module-next"};